import {lazy} from 'react';

export const InlineCountdownLazy = lazy(() => import(/* webpackChunkName: "InlineCountdown" */ '.'));
